module.exports = __webpack_public_path__ + "static/media/reservations-meeting-room.ce95dfbe.svg";